var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-draggable-resizable', {
    attrs: {
      "w": _vm.size.width,
      "h": _vm.size.height,
      "x": _vm.axis.x,
      "y": _vm.axis.y,
      "z-index": 9
    },
    on: {
      "dragging": _vm.onDrag,
      "resizing": _vm.onResize,
      "dragstop": _vm.update,
      "resizestop": _vm.update,
      "deactivated": _vm.update
    }
  }, [_vm.value.type === 'text-employer' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('v-text-field', {
    staticClass: "v-input--small",
    attrs: {
      "outlined": "",
      "placeholder": "텍스트를 입력해주세요."
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "small": "",
            "color": "grey"
          },
          on: {
            "click": function click() {
              _vm.$emit('close', _vm.value);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1)];
      },
      proxy: true
    }], null, false, 2051560001),
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1) : _vm._e(), _vm.value.type === 'text-employee' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('v-text-field', {
    staticClass: "v-input--small",
    attrs: {
      "readonly": "",
      "outlined": "",
      "placeholder": "근로자가 입력할 텍스트입니다."
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "small": "",
            "color": "grey"
          },
          on: {
            "click": function click() {
              _vm.$emit('close', _vm.value);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1)];
      },
      proxy: true
    }], null, false, 2051560001),
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1) : _vm._e(), _vm.value.type === 'check' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "small": "",
            "color": "grey"
          },
          on: {
            "click": function click() {
              _vm.$emit('close', _vm.value);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("mdi-close")])], 1)];
      },
      proxy: true
    }], null, false, 106433017),
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1)]) : _vm._e(), _vm.value.type === 'file' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('v-file-input', {
    staticClass: "v-input--small",
    attrs: {
      "disabled": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "small": "",
            "color": "grey"
          },
          on: {
            "click": function click() {
              _vm.$emit('close', _vm.value);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1)];
      },
      proxy: true
    }], null, false, 2051560001),
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1) : _vm._e(), _vm.value.type === 'canvas' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('canvas'), _c('v-btn', {
    staticStyle: {
      "top": "0",
      "right": "0"
    },
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "text": "",
      "icon": "",
      "small": "",
      "color": "grey"
    },
    on: {
      "click": function click() {
        _vm.$emit('close', _vm.value);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }